<script lang="ts">
    import { Link, useForm, page } from '@inertiajs/svelte';
    import { login } from '@/routes';

    let { token = '', email = '' }: { token: string; email: string } = $props();

    const form = useForm({
        token,
        email,
        password: '',
        password_confirmation: '',
    });

    const errors = $derived($page?.props?.errors ?? {});

    function submit(e: SubmitEvent) {
        e.preventDefault();
        $form.post('/reset-password');
    }
</script>

<svelte:head>
    <title>Reset Password — Case of the Day</title>
</svelte:head>

<div class="min-h-screen flex items-center justify-center bg-gray-950">
    <div class="bg-gray-900 rounded-lg shadow border border-gray-700 p-8 w-full max-w-lg">
        <h1 class="text-2xl font-bold text-gray-100 mb-2">Reset Password</h1>
        <p class="text-sm text-gray-400 mb-6">Choose a new password for your account.</p>

        <form onsubmit={submit} class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Email</label>
                <input
                    bind:value={$form.email}
                    type="email"
                    autocomplete="email"
                    required
                    class="w-full border rounded px-3 py-2 text-sm bg-gray-800 text-gray-100 {errors.email ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.email}<p class="text-red-500 text-sm mt-1">{errors.email}</p>{/if}
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">New Password</label>
                <input
                    bind:value={$form.password}
                    type="password"
                    autocomplete="new-password"
                    required
                    class="w-full border rounded px-3 py-2 text-sm bg-gray-800 text-gray-100 {errors.password ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.password}<p class="text-red-500 text-sm mt-1">{errors.password}</p>{/if}
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Confirm New Password</label>
                <input
                    bind:value={$form.password_confirmation}
                    type="password"
                    autocomplete="new-password"
                    required
                    class="w-full border rounded px-3 py-2 text-sm bg-gray-800 text-gray-100 {errors.password_confirmation ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.password_confirmation}<p class="text-red-500 text-sm mt-1">{errors.password_confirmation}</p>{/if}
            </div>
            <button type="submit" disabled={$form.processing} class="w-full bg-cyan-600 text-white py-2 rounded text-sm hover:bg-cyan-500 disabled:opacity-50">
                Reset Password
            </button>
        </form>

        <p class="mt-4 text-center text-sm text-gray-400">
            <Link href={login()} class="text-cyan-400 hover:text-cyan-300 hover:underline">Back to Sign In</Link>
        </p>
    </div>
</div>
